import React, { useState } from 'react'
import {Container,Row,Col,Button,Form} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from "../../context/auth/useAuth"
import { Link } from 'react-router-dom'
import Version from '../../version'

const clientCredentials = {};

export default function Login() {
    const { t } = useTranslation()
    const [islogging, setIslogging] = useState(false)
    const {loginClient} = useAuth()
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        loginClient(clientCredentials).then(() => {
            setIslogging(false)
        })
    }

    return (
        <Container fluid>
            <Row>
                <Col xs={12} lg={6} className='d-flex flex-column py-4'>
                    <div id="logotipo-auth" className='text-center text-md-start px-3 pb-5'><Link to="/"><img src="/images/logotipo-skill.svg" alt="Logotipo skillconnectED" /></Link></div>
                    <Container className='p-0 py-5 p-md-5'>
                        <Row>
                            <Col className='px-5'>
                                <h1>{t('signin.bienvenida')}</h1>
                                {t('signin.frase')}
                                <Form className="formulario" onSubmit={handleSubmit}>                                
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='login_email'>{t('signin.email')}</Form.Label>
                                            <Form.Control name="login_email" type="text" autoComplete="off" onChange={ (e) => clientCredentials.email = e.target.value} />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='login_password'>{t('signin.password')}</Form.Label>
                                            <Form.Control
                                                name="login_password"
                                                type={showPassword ? 'text' : 'password'}
                                                autoComplete="off"
                                                onChange={ (e) => clientCredentials.password = e.target.value}
                                                required
                                            />
                                            <i className={`fas fa-eye${showPassword ? '-slash' : ''} sd-eye`} onClick={() => setShowPassword(!showPassword)}></i>
                                            <div className='d-flex justify-content-end mt-2'>                                                
                                                <Link to="/forgotpassword" className='link'>{t('signin.forgotpassword')}</Link>
                                            </div>
                                            
                                        </Col>
                                    </Row>
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Button variant='primary' type="submit" className="w-100 my-2">
                                            {islogging
                                                ?
                                                <>
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </>
                                                :
                                                <>{t('signin.login')}</>
                                            }
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>                                
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-center'>
                                {t('signin.dontregister')}
                                <Link to="/registerlanding" className='ms-2 link'>{t('signin.register')}</Link>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-center my-3'>
                                <Version />
                            </Col>
                        </Row>
                    </Container>
                </Col>

                <Col lg={6} className='d-none d-lg-block vh-100 m-0 position-relative'>
                    <div className="video-background">
                        <video autoPlay loop muted>
                            <source src="/video/video-login.mp4" type="video/mp4" />                        
                            Tu navegador no soporta la reproducción de video.
                        </video>
                    </div>   
                </Col>
            </Row>
        </Container>
    )
}
